import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Contact() {
  const form = useRef<HTMLFormElement>(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sentSuccess, setSentSuccess] = useState(false);

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setNameError(!name);
    setEmailError(!email);
    setMessageError(!message);
    setSentSuccess(false);

    if (name && email && message) {
      setSending(true);
      emailjs
        .send(
          'service_n71af4s',
          'template_kxsp0af',
          { name, email, message },
          'M7jSDcBESligxMk5b'
        )
        .then(
          () => {
            setSending(false);
            setSentSuccess(true);
            setName('');
            setEmail('');
            setMessage('');
            setTimeout(() => setSentSuccess(false), 4000);
          },
          (err) => {
            console.error('EmailJS error:', err);
            setSending(false);
            alert('Failed to send message. Please try again later.');
          }
        );
    }
  };

  /* ----------  MUI sx that really works  ---------- */
  const inputSx = {
    width: '100%',
    /* Input text colour */
    '& .MuiInputBase-input': {
      color: 'var(--text-color) !important',
    },
    '& .MuiInputBase-inputMultiline': {
      color: 'var(--text-color) !important',
    },
    /* Placeholder */
    '& .MuiInputBase-input::placeholder': {
      color: 'var(--placeholder-color)',
      opacity: 1,
    },
    /* Label */
    '& .MuiInputLabel-root': {
      color: 'var(--label-color)',
    },
    /* Outline */
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: 'var(--border-color)' },
      '&:hover fieldset': { borderColor: '#1976d2' },
      '&.Mui-focused fieldset': { borderColor: '#1976d2' },
    },
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>
            Got a project waiting to be realized? Let’s collaborate and make it
            happen!
          </p>

          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className="contact-form"
            onSubmit={sendEmail}
          >
            <div className="form-flex">
              <TextField
                required
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={nameError}
                helperText={nameError ? 'Please enter your name' : ''}
                sx={inputSx}
              />
              <TextField
                required
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={
                  emailError ? 'Please enter your email or phone number' : ''
                }
                sx={inputSx}
              />
            </div>

            <TextField
              required
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              error={messageError}
              helperText={messageError ? 'Please enter the message' : ''}
              sx={inputSx}
            />

            <Button
              type="submit"
              variant="contained"
              endIcon={<SendIcon />}
              disabled={sending}
              sx={{
                mt: 2,
                backgroundColor: '#1976d2',
                '&:hover': { backgroundColor: '#1565c0' },
              }}
            >
              {sending ? 'Sending...' : 'Send'}
            </Button>

            {sentSuccess && (
              <div className="success-msg">
                <CheckCircleIcon color="success" sx={{ mr: 0.5 }} />
                Message sent successfully!
              </div>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;